import styled, { css } from 'styled-components';

import { LIQUID_ID_ASPECT_RATIO } from '../config';

interface Props {
    $mobilePointersAllowed?: boolean;
    $standalone?: boolean;
}

export const LiquidIDCanvasWrapper = styled.div<Props>`
    position: relative;
    aspect-ratio: ${LIQUID_ID_ASPECT_RATIO};
    z-index: 1;
    width: 440px;

    ${({ $mobilePointersAllowed }) =>
        !$mobilePointersAllowed &&
        css`
            // pointer-events: none;
        `}

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        pointer-events: auto;
    }
`;

interface WebGLProps {
    $noPointer?: boolean;
    onClick?: () => void;
}

export const StyledWebGL = styled.div<WebGLProps>`
    cursor: pointer;
    width: 100%;
    height: 100%;
    z-index: 0;

    background: transparent !important;

    ${({ $noPointer }) =>
        $noPointer &&
        css`
            cursor: initial;
        `}
`;
